import { render, staticRenderFns } from "./TeamRequestsManager.vue?vue&type=template&id=cc5f8cbe&scoped=true"
import script from "./teamRequestsManager.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestsManager.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestsManager.vue?vue&type=style&index=0&id=cc5f8cbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5f8cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc5f8cbe')) {
      api.createRecord('cc5f8cbe', component.options)
    } else {
      api.reload('cc5f8cbe', component.options)
    }
    module.hot.accept("./TeamRequestsManager.vue?vue&type=template&id=cc5f8cbe&scoped=true", function () {
      api.rerender('cc5f8cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/manager/team-requests/TeamRequestsManager.vue"
export default component.exports